// Having an AMD require in the bundle makes sure the universalTypeahead module is loaded
// Since the universalTypeahead AMD module requires UITK, this will load after UITK is loaded.
var utaScriptLoadingStartedTimestamp = Date.now();
require('universalTypeahead', function (uTA) {
    window.utaModuleReadyTimeStamp = Date.now();
    uTA.handlePageLoad();
    // What is this thing doing?
    // We look for any elements with attribute 'data-provide="utypeahead"' and if we
    // find any then we attach a focus handler using uTA.
    // This works in a similar manner to uitk-typeahead
    // (See http://uitoolkit.sb.karmalab.net/uitoolkit-current/docs/components/interactive/type-ahead)
    //
    //      data-provide="utypeahead"
    //      data-template="#uitk-ta-default || #uitk-ta-by-category"
    //      data-js-theme="typeahead || typeahead-by-category"
    //
    var dataProvideAttr = '[data-provide=utypeahead]';

    // If an element has the attribute 'data-provide={typeahead provider string}' then we
    // use that to attach a typeahead instance to it if there is also a 'data-template="<uitk template name>"'
    // and a 'data-js-theme="<uitk js theme name>"'
    // we are listening to focus, input, change event for search input to attach uTA
    // We added change event listener to address the following issue related to ta metaData
    // https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/5225
    $('body').on('focus.typeahead input.typeahead change.typeahead', dataProvideAttr, function (evt, evtTrigger) {

        var $el = $(this),
            inputId,
            template, // UITK required attribute
            jsTheme, // UITK required attribute
            options;

        // If this element already has a typeahead instance associated with it,
        // then there's nothing to do here so we just move along.
        if ($el.attr('data-typeahead')) {
            return;
        }

        inputId = '#' + $el.attr('id');
        template = $el.data('template');
        jsTheme = $el.data('jsTheme');
        options = $el.data();

        // OK, all criteria seem to be met,
        // create a new uTA and associate with this element
        uTA.initTA(inputId, template, options);

        // Mark the element so that it does not reattach with another uTA instance later
        $el.attr('data-typeahead', "uTA-attached");
    });
});

require(["typeahead/core/presentation/SvgIcons"], function(s) {
    s.SvgIcons.init();
});

// DO EGTA DNS priming at page load
require(["typeahead/core/context", "jquery"], function(context, $) {
    $.getJSON("/egta/api/v4/typeahead/");
});
